// extracted by mini-css-extract-plugin
module.exports = {"card-container":"DocCard_card-container__2bWEB","card-content":"DocCard_card-content__2eW2b"};